module.exports = __webpack_public_path__ + "img/diagram-lean-canvas.f03669e7.svg";